import React from 'react';
import { View, StyleSheet } from 'react-native';
var styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row'
  },
  skeleton: {
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
    overflow: 'hidden'
  },
  skeletonBlock: {
    width: 80,
    height: 80,
    marginBottom: 8,
    marginRight: 8,
    marginLeft: 8,
    marginTop: 8,
    backgroundColor: '#FAFAFA'
  },
  skeletonLineWrapper: {
    marginLeft: 10
  },
  skeletonLine: {
    width: 255,
    height: 14,
    marginBottom: 8,
    marginTop: 8,
    backgroundColor: '#FAFAFA'
  },
  skeletonLineLast: {
    marginBottom: 8,
    marginTop: 8,
    backgroundColor: '#FAFAFA',
    width: 165,
    height: 14
  }
});
export default (function () {
  return /*#__PURE__*/React.createElement(View, {
    style: styles.wrapper
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.skeletonBlock
  }), /*#__PURE__*/React.createElement(View, {
    style: styles.skeletonLineWrapper
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.skeletonLine
  }), /*#__PURE__*/React.createElement(View, {
    style: styles.skeletonLine
  }), /*#__PURE__*/React.createElement(View, {
    style: styles.skeletonLineLast
  })));
});